__turbopack_context__.v({
  "draft": "DraftIndicator-module-scss-module__fqlSLG__draft",
  "draft__tag": "DraftIndicator-module-scss-module__fqlSLG__draft__tag",
});
